import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "43",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F391BD",
      d: "M30.923 11.875v25.943A5.18 5.18 0 0 1 25.741 43H5.181A5.18 5.18 0 0 1 0 37.818V5.182A5.18 5.18 0 0 1 5.182 0h13.866z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F6ACCE",
      d: "M30.923 11.875H21.19a2.14 2.14 0 0 1-2.142-2.141V0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12.262 23.18c0 1.789-.95 2.78-2.62 2.78H8.616v2.998H7.39v-8.533h2.25c1.672 0 2.62 1.016 2.62 2.755m-1.26 0c0-1.05-.454-1.588-1.377-1.588H8.617v3.192h1.008c.932.008 1.377-.504 1.377-1.604M13.303 20.425h2.117c1.654 0 2.628.974 2.628 2.654v3.191c0 1.688-.974 2.68-2.62 2.68h-2.133v-8.525zm2.133 7.357c.874 0 1.378-.52 1.378-1.537v-3.14c0-1-.487-1.513-1.377-1.513h-.9v6.19zM20.744 21.584v2.545h2.57v1.117h-2.57v3.704h-1.226v-8.525h4.023v1.159z"
    }, null, -1)
  ])))
}
export default { render: render }